import React from 'react';
import {
  inject,
  observer
} from 'mobx-react';
import CardCheckingNew from '../../hrmAttendance/components/Checking';


@inject('hrmCard')
@observer
export default class CheckIngNew extends React.Component {
  render(){
    return React.cloneElement(<CardCheckingNew ecId={`${this && this.props && this.props.ecId || ''}_CardCheckingNew@mvpzoi`} />, {
      ...this.props
    });
  }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/CheckingNew.js